const red = {
  100: '#E2000F'
};

export { red };
